
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.default || mod) {
      router.addRoute(route)
    }
    router.replace('')
  })
}

export function handleHotUpdate(_router) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
  }
}
import { default as _91_46_46_46slug_938fa7XbQok6Meta } from "/var/www/projects/nuxt.hillceramic.no/releases/20261105070052Z/pages/[...slug].vue?macro=true";
import { default as _91_46_46_46slug_93p1RdfsHjFhMeta } from "/var/www/projects/nuxt.hillceramic.no/releases/20261105070052Z/pages/blogg/[...slug].vue?macro=true";
import { default as indexVtxBsF8SlMMeta } from "/var/www/projects/nuxt.hillceramic.no/releases/20261105070052Z/pages/blogg/index.vue?macro=true";
import { default as indexWe5xi8BXRNMeta } from "/var/www/projects/nuxt.hillceramic.no/releases/20261105070052Z/pages/checkout/index.vue?macro=true";
import { default as paymentzCZ6l4pMgDMeta } from "/var/www/projects/nuxt.hillceramic.no/releases/20261105070052Z/pages/checkout/payment.vue?macro=true";
import { default as index_46clientf0lDGXLf9PMeta } from "/var/www/projects/nuxt.hillceramic.no/releases/20261105070052Z/pages/checkout/thank-you/index.client.vue?macro=true";

let _createClientPage
async function createClientPage(loader) {
  _createClientPage ||= await import("/var/www/projects/nuxt.hillceramic.no/releases/20261105070052Z/node_modules/nuxt/dist/components/runtime/client-component.js").then(r => r.createClientPage)
  return _createClientPage(loader);
}
import { default as indexkiU10aaPaJMeta } from "/var/www/projects/nuxt.hillceramic.no/releases/20261105070052Z/pages/collections/index.vue?macro=true";
import { default as _91slug_93ewHJQEgrGoMeta } from "/var/www/projects/nuxt.hillceramic.no/releases/20261105070052Z/pages/faq/[slug].vue?macro=true";
import { default as indexr5I8OEYHxKMeta } from "/var/www/projects/nuxt.hillceramic.no/releases/20261105070052Z/pages/hillceramic-rabattkoder/index.vue?macro=true";
import { default as indexwnPgAnhT8mMeta } from "/var/www/projects/nuxt.hillceramic.no/releases/20261105070052Z/pages/index.vue?macro=true";
import { default as indexAWxCm0jy0eMeta } from "/var/www/projects/nuxt.hillceramic.no/releases/20261105070052Z/pages/login/index.vue?macro=true";
import { default as _91id_93bH8IHZZo7WMeta } from "/var/www/projects/nuxt.hillceramic.no/releases/20261105070052Z/pages/qr-pr/[id].vue?macro=true";
import { default as formOU7qPHdcf2Meta } from "/var/www/projects/nuxt.hillceramic.no/releases/20261105070052Z/pages/review/form.vue?macro=true";
import { default as indexoWjUIO2HLUMeta } from "/var/www/projects/nuxt.hillceramic.no/releases/20261105070052Z/pages/review/index.vue?macro=true";
import { default as _91_46_46_46slug_932odPQ2AlgPMeta } from "/var/www/projects/nuxt.hillceramic.no/releases/20261105070052Z/pages/shop/[...slug].vue?macro=true";
import { default as indexyuNBpERkU5Meta } from "/var/www/projects/nuxt.hillceramic.no/releases/20261105070052Z/pages/track/index.vue?macro=true";
export default [
  {
    name: "slug___no",
    path: "/:slug(.*)*",
    meta: _91_46_46_46slug_938fa7XbQok6Meta || {},
    component: () => import("/var/www/projects/nuxt.hillceramic.no/releases/20261105070052Z/pages/[...slug].vue")
  },
  {
    name: "blogg-slug___no",
    path: "/blogg/:slug(.*)*",
    component: () => import("/var/www/projects/nuxt.hillceramic.no/releases/20261105070052Z/pages/blogg/[...slug].vue")
  },
  {
    name: "blogg___no",
    path: "/blogg",
    component: () => import("/var/www/projects/nuxt.hillceramic.no/releases/20261105070052Z/pages/blogg/index.vue")
  },
  {
    name: "checkout___no",
    path: "/checkout",
    meta: indexWe5xi8BXRNMeta || {},
    component: () => import("/var/www/projects/nuxt.hillceramic.no/releases/20261105070052Z/pages/checkout/index.vue")
  },
  {
    name: "checkout-payment___no",
    path: "/checkout/payment",
    meta: paymentzCZ6l4pMgDMeta || {},
    component: () => import("/var/www/projects/nuxt.hillceramic.no/releases/20261105070052Z/pages/checkout/payment.vue")
  },
  {
    name: "checkout-thank-you___no",
    path: "/checkout/thank-you",
    meta: index_46clientf0lDGXLf9PMeta || {},
    component: () => createClientPage(() => import("/var/www/projects/nuxt.hillceramic.no/releases/20261105070052Z/pages/checkout/thank-you/index.client.vue"))
  },
  {
    name: "collections___no",
    path: "/kolleksjoner",
    component: () => import("/var/www/projects/nuxt.hillceramic.no/releases/20261105070052Z/pages/collections/index.vue")
  },
  {
    name: "faq-slug___no",
    path: "/faq/:slug()",
    component: () => import("/var/www/projects/nuxt.hillceramic.no/releases/20261105070052Z/pages/faq/[slug].vue")
  },
  {
    name: "hillceramic-rabattkoder___no",
    path: "/hillceramic-rabattkoder",
    component: () => import("/var/www/projects/nuxt.hillceramic.no/releases/20261105070052Z/pages/hillceramic-rabattkoder/index.vue")
  },
  {
    name: "index___no",
    path: "/",
    component: () => import("/var/www/projects/nuxt.hillceramic.no/releases/20261105070052Z/pages/index.vue")
  },
  {
    name: "login___no",
    path: "/login",
    component: () => import("/var/www/projects/nuxt.hillceramic.no/releases/20261105070052Z/pages/login/index.vue")
  },
  {
    name: "qr-pr-id___no",
    path: "/qr-pr/:id()",
    component: () => import("/var/www/projects/nuxt.hillceramic.no/releases/20261105070052Z/pages/qr-pr/[id].vue")
  },
  {
    name: "review-form___no",
    path: "/review/form",
    component: () => import("/var/www/projects/nuxt.hillceramic.no/releases/20261105070052Z/pages/review/form.vue")
  },
  {
    name: "review___no",
    path: "/review",
    meta: indexoWjUIO2HLUMeta || {},
    component: () => import("/var/www/projects/nuxt.hillceramic.no/releases/20261105070052Z/pages/review/index.vue")
  },
  {
    name: "shop-slug___no",
    path: "/shop/:slug(.*)*",
    component: () => import("/var/www/projects/nuxt.hillceramic.no/releases/20261105070052Z/pages/shop/[...slug].vue")
  },
  {
    name: "track___no",
    path: "/track",
    meta: indexyuNBpERkU5Meta || {},
    component: () => import("/var/www/projects/nuxt.hillceramic.no/releases/20261105070052Z/pages/track/index.vue")
  }
]